import { render } from "./CoaRetrieval.vue?vue&type=template&id=953abf7c&scoped=true"
import script from "./CoaRetrieval.vue?vue&type=script&lang=js"
export * from "./CoaRetrieval.vue?vue&type=script&lang=js"

import "./CoaRetrieval.vue?vue&type=style&index=0&id=953abf7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-953abf7c"]])

export default __exports__